import { render, staticRenderFns } from "./createNewPart2.vue?vue&type=template&id=7c53206e&scoped=true&"
import script from "./createNewPart2.vue?vue&type=script&lang=js&"
export * from "./createNewPart2.vue?vue&type=script&lang=js&"
import style0 from "./createNewPart2.vue?vue&type=style&index=0&id=7c53206e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c53206e",
  null
  
)

export default component.exports